import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { LocalDBService } from '../../../local-db.service';
@Component({
  selector: 'app-work-order-id',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="hazard-description">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <input class="form-control pointer-events" value="{{field.value}}">
  </div>
</div>
    `,
  styles: [`.pointer-events{background-color:#E6E6E7}`]
})
export class WorkOrderIdComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor(
    private _validationService: ValidationService,
    private _localDBService: LocalDBService
  ) { }

  ngOnInit() {
    if (this.field.value === undefined) {
      var self = this;
      this._localDBService.getData(['workOrderId', 'workOrderCount'], function (inspectionDetails) {

        if (inspectionDetails) {

          self.field.value = 'W-' + inspectionDetails.workOrderId + '-' + inspectionDetails.workOrderCount;

          inspectionDetails.workOrderCount = (parseInt(inspectionDetails['workOrderCount']) + 1).toString();
          self._localDBService.updateInspectionDetails(inspectionDetails);
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/work-order-id/work-order-id.ts